import { Button, createStyles, Dialog, DialogTitle, Divider, Link, makeStyles, TextField, Theme, Typography, withStyles } from "@material-ui/core";
import * as React from "react";
import * as ThemeConstants from "../../Styles/Constants";
import { useHistory, useParams } from "react-router";
import { useWindowDimensions } from "../UI/UseWindowDimensions";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {

        },
    })
);

const StyledTextField = withStyles({
    root: {
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: ThemeConstants.PALETTE_DARK_WHITE,
                borderWidth: "2px"
            },
            '&:hover fieldset': {
                borderColor: ThemeConstants.PALETTE_WHITE,
                borderWidth: "3px"
            },
            '&.Mui-focused fieldset': {
                borderColor: ThemeConstants.PALETTE_WHITE,
                borderWidth: "3px"
            },
        },
    },
})(TextField);

export const JoinPage = () => {
    const classes = useStyles();
    const history = useHistory();

    const { roomIdString } = useParams<{ roomIdString: string; }>();

    const [name, setName] = React.useState("");

    const confirm = () => {
        localStorage.setItem("playerName", name);

        if (roomIdString.toLowerCase() == "new") { // new lobby
            history.push(`/play/0/${name}`);
        } else {
            history.push(`/play/${roomIdString}/${name}`);
        }
    }

    const onKeyDown = (e: React.KeyboardEvent) => {
        if (e.key == "Enter" && name != "") {
            confirm();
        }
    }

    React.useEffect(() => {
        const foundName = localStorage.getItem("playerName");
        if (foundName)
            setName(foundName);
    }, [])

    return (
        <div className={classes.root}>
            <Dialog open={true} fullWidth maxWidth={'sm'}>
                <DialogTitle>Before you join...</DialogTitle>
                <div style={{ display: "flex", alignItems: "center", flexDirection: "column", gap: "1rem", marginBottom: "1rem" }}>
                    <StyledTextField
                        label={name == "" ? "Your Name" : ""}
                        variant="outlined"
                        autoFocus
                        style={{ width: "95%" }}
                        inputProps={{
                            style: { fontSize: "25px" },
                            maxLength: 20
                        }}
                        InputLabelProps={{
                            style: {
                                fontSize: "25px",
                                color: ThemeConstants.PALETTE_LIGHT_GREY
                            },
                            shrink: false
                        }}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        onKeyDown={onKeyDown}
                    />
                    <div style={{ display: "flex", gap: "1rem" }}>
                        <Button onClick={confirm} disabled={name == ""} variant="contained" color="primary">
                            Confirm
                        </Button>
                        <Button onClick={() => history.push("/")} variant="contained" color="secondary">
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}